import { Fragment } from "react";
import {
  IsExcluded,
  RemoveFromMailExclusion,
} from "../../api/suppressionService";
import { SuppressionCheckForm } from "./SuppressionCheckForm";
import { useSuppressionCheck } from "./useSuppressionCheck";

export interface Exclusion {
  Reason?: string;
  Esp?: string;
  Source?: string;
}

/** Why an address is excluded, laid out as a record card's lines are. */
export function ExclusionDetails({ exclusion }: { exclusion: Exclusion }) {
  return (
    <dl className="row gy-1 mt-2 mb-0">
      {(["Reason", "Esp", "Source"] as const).map((key) => (
        <Fragment key={key}>
          <dt className="col-4 fw-normal">{key}</dt>
          <dd className="col-8 mb-0 text-break">{exclusion[key] || "-"}</dd>
        </Fragment>
      ))}
    </dl>
  );
}

export function MailExclusionCheck() {
  const check = useSuppressionCheck({
    check: IsExcluded,
    remove: RemoveFromMailExclusion,
    isListed: (data) => data.Exclusion != null,
    checkFailedMessage: "Error checking mail exclusion",
    removeFailedMessage: "Error removing mail exclusion",
    listedMessage: (email) => `${email} is currently being excluded`,
    notListedMessage: (email) => `${email} is currently not being excluded`,
    removedMessage: (email) =>
      `${email} has been successfully removed from the mail exclusion`,
    notRemovedMessage: (email) =>
      `Unable to remove ${email} from the mail exclusion`,
  });
  const exclusion = (check.checkData?.Exclusion ?? {}) as Exclusion;

  return (
    <SuppressionCheckForm
      name="mailExclusionEmailAddress"
      check={check}
      checkText="Check Mail Exclusion"
      removeText="Remove"
      details={<ExclusionDetails exclusion={exclusion} />}
    />
  );
}
